/** What ending a session means, as a pure decision. */

import { looksLikeAddress } from './format';
import { SIGNIN_HASH } from './routes';

export type SignOutReason = 'user' | 'expired' | 'elsewhere';

export interface SignOutOutcome {
  session: null;
  notice: string | null;
  hash: string;
  /** Whether the server-side record is worth dropping (pointless once the API refused the token). */
  revoke: boolean;
}

export const SESSION_ENDED_NOTICE = 'Your session ended. Sign in again to continue.';
export const SIGNED_OUT_ELSEWHERE_NOTICE = 'You were signed out.';

export function signOutTo(reason: SignOutReason): SignOutOutcome {
  return { session: null, notice: reason === 'expired' ? SESSION_ENDED_NOTICE : reason === 'elsewhere' ? SIGNED_OUT_ELSEWHERE_NOTICE : null, hash: SIGNIN_HASH, revoke: reason === 'user' };
}

/** The name on screen. A Home that knows someone by phone number asserts no name; say "You", not hex. */
export function displayName(session: { name: string; agentName?: string | undefined; address?: string | undefined }): string {
  const agent = session.agentName?.trim();
  if (agent && !looksLikeAddress(agent)) return agent;
  const name = session.name?.trim() ?? '';
  if (name && !looksLikeAddress(name)) return name;
  return 'You';
}

export function firstName(name: string): string {
  const n = name.trim();
  if (!n || looksLikeAddress(n)) return 'there';
  return n.split(/\s+/)[0] ?? n;
}
